import styled from '../../config/theme'

const Content = styled.div`
  padding: 20px;
`

export {
  Content,
}
